// import axios from "axios";

// const axiosInsatnace = axios.create({
//   baseURL: "https://console.indmatrimony.in/api/v2/",
//   timeout: 50000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });
// //  baseURL: "https://api.inddevelopment.in/api/",
// // baseURL: "https://console.indmatrimony.in/api/",
// export default axiosInsatnace;











import axios from "axios";

const axiosInsatnace = axios.create({
  baseURL: process.env.REACT_APP_PHP_API_BASE_URL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInsatnace;
